<template>
  <div>
    <div class="col-sm-3">
      <select class="form-select" name="cars" id="cars">
        <option value="volvo">Volvo</option>
        <option value="saab">Saab</option>
        <option value="mercedes" class="col-sm-3" style=""
          >Mercedesssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssseeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee</option
        >
        <option value="audi">Audi</option>
      </select>
    </div>
    <input :value="selected" />
  </div>
</template>

<script>
// import _ from "lodash";
import $ from "jquery";
export default {
  data() {
    return {
      list: ["one", "two", "three"],
      selected: "two",
      previouslySelected: "two",
    };
  },
  methods: {
    cbChange(obj) {
      var instate = document.getElementById(obj).checked;
      var cbs = document.getElementsByClassName("cb");
      for (var i = 0; i < cbs.length; i++) {
        cbs[i].checked = false;
      }
      if (instate) document.getElementById(obj).checked = true;
    },
  },
  mounted() {
    var maxLength = 35;
    $("#cars > option").text(function(i, text) {
      if (text.length > maxLength) {
        return text.substr(0, maxLength) + "...";
      }
    });
  },
};
</script>

<style></style>
